import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-1 text-sm text-red-600"
}
const _hoisted_2 = {
  key: 1,
  class: "mt-2 text-red-600"
}
const _hoisted_3 = { class: "text-sm font-medium" }
const _hoisted_4 = {
  key: 0,
  class: "mt-1 text-sm"
}

import { computed, ref, watch } from 'vue'

import FormElement from '@/components/neue/FormElement.vue'
import FormSection from '@/components/neue/FormSection.vue'
import InputField from '@/components/neue/InputField.vue'
import NeueButton from '@/components/neue/NeueButton.vue'
import NeueCheckbox from '@/components/neue/NeueCheckbox.vue'
import TheModal from '@/components/TheModal.vue'
import { refundFormState } from '@/helpers/refund'


export default {
  __name: 'RefundModal',
  props: {
  isOpen: { type: Boolean, default: false },
  maxRefundCents: { type: Number, default: 0 },
  isLoading: { type: Boolean, default: false },
  errorMessage: { type: String, default: '' },
  errorLog: { type: String, default: '' }
},
  emits: ['close', 'submit'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const amount = ref('')
const confirmed = ref(false)

const state = computed(() => refundFormState(amount.value, props.maxRefundCents, confirmed.value))

watch(
  () => props.isOpen,
  isOpen => {
    if (isOpen) {
      amount.value = ''
      confirmed.value = false
    }
  }
)

const onSubmit = () => {
  if (!state.value.canSubmit) return
  emit('submit', state.value.amountCents)
}

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(TheModal, {
    "is-open": __props.isOpen,
    "modal-title": "Issue a refund",
    onCloseModal: _cache[3] || (_cache[3] = $event => (emit('close')))
  }, {
    main: _withCtx(() => [
      _createVNode(FormSection, {
        onSubmit: _withModifiers(onSubmit, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(FormElement, null, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createElementVNode("p", { class: "text-sm text-gray-500" }, " Enter the amount you'd like to refund the customer. Refunds will be deducted from your Stripe Payout. Please note: Stripe and Bottle fees are not refundable and will still be deducted from your next payout. Uber Direct delivery fees are never refunded. ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(FormElement, null, {
            default: _withCtx(() => [
              _createVNode(InputField, {
                modelValue: amount.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((amount).value = $event)),
                prefix: "$",
                restrict: "monetary",
                name: "Refund amount",
                error: state.value.exceedsMax
              }, null, 8, ["modelValue", "error"]),
              (state.value.exceedsMax)
                ? (_openBlock(), _createElementBlock("p", _hoisted_1, " Refund cannot exceed the refundable amount on this order. "))
                : _createCommentVNode("", true),
              (__props.errorMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(__props.errorMessage), 1),
                    (__props.errorLog)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(__props.errorLog), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(FormElement, null, {
            default: _withCtx(() => [
              _createVNode(NeueCheckbox, {
                modelValue: confirmed.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((confirmed).value = $event)),
                name: "I understand Stripe, Bottle, and Uber Direct delivery fees are not refundable."
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(NeueButton, {
        type: "secondary",
        onClick: _cache[2] || (_cache[2] = $event => (emit('close')))
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
          _createTextVNode("Cancel", -1)
        ]))]),
        _: 1
      }),
      _createVNode(NeueButton, {
        type: state.value.canSubmit ? 'primary' : 'inactive',
        disabled: !state.value.canSubmit || __props.isLoading,
        onClick: onSubmit
      }, {
        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
          _createTextVNode(" Refund ", -1)
        ]))]),
        _: 1
      }, 8, ["type", "disabled"])
    ]),
    _: 1
  }, 8, ["is-open"]))
}
}

}